import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/pages/home/components/Footer';
import { categoryData, categoryArticles } from '@/mocks/category';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();

  const cat = slug ? categoryData[slug] : null;

  if (!cat) {
    return (
      <div className="min-h-screen bg-background-50 flex items-center justify-center">
        <div className="text-center">
          <p className="text-lg text-foreground-500 mb-4">该分类不存在</p>
          <a href="/" className="text-primary-500 font-semibold hover:text-primary-600 transition-colors whitespace-nowrap">
            返回首页
          </a>
        </div>
      </div>
    );
  }

  const filteredArticles = categoryArticles.filter((a) => {
    if (slug === 'wanghong') return a.category === '网红黑料';
    if (slug === 'mingxing') return a.category === '明星八卦';
    if (slug === 'shehui') return a.category === '社会热点';
    if (slug === 'yule') return a.category === '娱乐圈';
    return true;
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main>
        <section className="relative pt-20">
          <div className="relative h-[240px] md:h-[320px] overflow-hidden">
            <img
              src={cat.banner}
              alt={`${cat.title} - 爆料专区分类`}
              title={`${cat.title} - ${cat.description}`}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10 max-w-7xl mx-auto">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-8 h-8 rounded-lg bg-primary-500/20 flex items-center justify-center">
                  <i className={`${cat.icon} text-primary-500`}></i>
                </div>
                <span className="text-sm font-semibold text-background-50/80">{cat.title}</span>
              </div>
              <h1 className="text-2xl md:text-4xl font-heading font-black text-background-50 mb-2">
                {cat.title}
              </h1>
              <p className="text-sm md:text-base text-background-50/70 max-w-xl">
                {cat.description}
              </p>
            </div>
          </div>
        </section>

        <section className="py-8 md:py-12 px-4 md:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-2 mb-6">
              <button
                onClick={() => navigate('/')}
                className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                首页
              </button>
              <i className="ri-arrow-right-s-line text-foreground-400 text-sm"></i>
              <span className="text-sm text-foreground-800 font-medium">{cat.title}</span>
              <span className="text-xs text-foreground-400 ml-2">({filteredArticles.length} 条爆料)</span>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {filteredArticles.map((article) => (
                <a
                  key={article.id}
                  href={`/article/${article.id}`}
                  className="group block rounded-xl overflow-hidden bg-background-100 hover:-translate-y-1 transition-all duration-300"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      title={`${article.title} - ${article.category}独家爆料`}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute top-3 right-3">
                      <span className={`px-2.5 py-1 rounded-full text-[11px] font-bold whitespace-nowrap ${
                        article.tag === '爆'
                          ? 'bg-primary-500 text-background-50'
                          : article.tag === '独家'
                            ? 'bg-background-50 text-primary-500 border border-primary-300'
                            : 'bg-accent-500 text-background-50'
                      }`}>
                        {article.tag}
                      </span>
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-foreground-950/80 to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-4">
                      <h3 className="text-sm md:text-base font-bold text-background-50 leading-snug line-clamp-2">
                        {article.title}
                      </h3>
                    </div>
                  </div>
                  <div className="p-4">
                    <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
                      {article.summary}
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-foreground-500">{article.time}</span>
                      <span className="text-xs text-foreground-400 flex items-center gap-1">
                        <i className="ri-eye-line text-xs"></i>
                        {article.reads}
                      </span>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}